<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <i class="fas fa-list"></i>
      {{ $t('page.title.mail_box') }}
    </page-header>
    <page-card>
      <template v-slot:header>
        {{ $t('page.filters') }}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">
          <div class="row">
            <div class="col-4">
              <filter-input
                  :filter-query="filterQuery"
                  :filter-operator="'like'"
                  filter-name="id"
                  :label="$t('filters.label.message.id')"
                  :placeholder="$t('filters.placeholder.message.id')">
              </filter-input>
            </div>
            <div class="col-4">
              <filter-input
                  :filter-query="filterQuery"
                  :filter-operator="'like'"
                  filter-name="topic"
                  :label="$t('filters.label.message.topic')"
                  :placeholder="$t('filters.placeholder.message.topic')">
              </filter-input>
            </div>
            <div class="col-4">
              <filter-input
                  :filter-query="filterQuery"
                  :filter-operator="'like'"
                  filter-name="playerNickName"
                  :label="$t('filters.label.message.playerNickName')"
                  :placeholder="$t('filters.placeholder.message.playerNickName')">
              </filter-input>
            </div>
          </div> <!-- #row-->

          <div class="row">
            <div class="col-4">
              <filter-input
                  :filter-query="filterQuery"
                  :filter-operator="'like'"
                  filter-name="playerEmail"
                  :label="$t('filters.label.message.playerEmail')"
                  :placeholder="$t('filters.placeholder.message.playerEmail')">
              </filter-input>
            </div>
            <div class="col-4">
              <filter-select
                  :filter-query="filterQuery"
                  :options="countries"
                  :multiple="false"
                  options-label="text"
                  options-track-by="value"
                  filter-name="playerCountry"
                  :label="$t('filters.label.message.playerCountry')"
                  :placeholder="$t('filters.placeholder.message.playerCountry')">>
              </filter-select>
            </div>
            <div class="col-4">
              <filter-select
                  :filter-query="filterQuery"
                  :options="selectOptions.status"
                  :multiple="false"
                  options-label="text"
                  options-track-by="value"
                  filter-name="status"
                  :label="$t('filters.label.message.status')"
                  :placeholder="$t('filters.placeholder.message_status')">
              </filter-select>
            </div>
          </div> <!-- #row-->

          <div class="row">
            <div class="col-4">
              <filter-date-range-picker
                  :filter-query="filterQuery"
                  :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                  :auto="true"
                  :linked="false"
                  :time-picker="true"
                  filter-name="firstMessageDate"
                  open-direction="left"
                  :label="$t('filters.label.first_messageDate')">
              </filter-date-range-picker>
            </div>

            <div class="col-4">
              <filter-date-range-picker
                  :filter-query="filterQuery"
                  :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                  :auto="true"
                  :linked="false"
                  :time-picker="true"
                  filter-name="lastMessageDate"
                  open-direction="left"
                  :label="$t('filters.label.last_messageDate')">
              </filter-date-range-picker>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <b-button @click="resetFilters()" variant="secondary">{{ $t('filters.btn.clear') }}</b-button>
        <b-button @click="applyFilters()" variant="primary">{{ $t('filters.btn.apply') }}</b-button>
      </template>
    </page-card>

    <div class="row mt-2">
      <div class="col-12">
        <div class="questions sygni-grid">
            <div class="row mt-2">
              <div class="col-12">
                <grid-pagination :total-count="totalCount"
                                 :per-page="perPage"
                                 :current-page="currentPage"
                                 @load-items="paginationReload"></grid-pagination>

                <div class="table-responsive">
                  <b-table striped show-empty
                           :empty-text="$t('table.no_results')"
                           :busy="isBusy"
                           hover
                           head-variant="dark"
                           outlined
                           :sort-by.sync="orderColumn"
                           :sort-desc.sync="orderDirection"
                           :no-local-sorting="true"
                           :items="items"
                           :fields="fields">

                    <template #cell(id)="data">
                      <div>
                        {{ data.item.id | shortId }}
                      </div>
                    </template>

                    <template #cell(playerCountry)="data">
                      <div v-for="item of countries" :key="item.id">
                        <template v-if="item.value === data.item.playerCountry">
                          {{ item.text }}
                        </template>
                      </div>
                    </template>

                    <template #cell(firstMessageDate)="data">
                      <div>
                        {{ data.item.firstMessageDate | dateFormat }}
                      </div>
                    </template>

                    <template #cell(lastMessageDate)="data">
                      <div>
                        {{ data.item.lastMessageDate | dateFormat }}
                      </div>
                    </template>

                    <template #cell(status)="data">
                      <b-badge pill variant="success" v-if="data.value === 'open'">{{ $t('table.messages.is_open') }}</b-badge>
                      <b-badge pill variant="danger" v-if="data.value === 'closed'">{{ $t('table.messages.is_closed') }}</b-badge>
                    </template>

                    <template #cell(actions)="data">
                      <div class="table-action--cell">
                        <b-button variant="primary" size="sm" @click="openModal(data.item)">
                          {{ $t('table.btn.messages.show') }}
                        </b-button>
                      </div>
                    </template>
                  </b-table>

                </div> <!-- #table-responsive-->

                <grid-pagination :total-count="totalCount"
                                 :per-page="perPage"
                                 :current-page="currentPage"
                                 @load-items="paginationReload"></grid-pagination>

              </div>
            </div>
<!--          </div> &lt;!&ndash; #card-body&ndash;&gt;-->
        </div> <!-- #card questions sygni-grid-->
      </div>
    </div>

    <div v-if="isBusy" class="spinner-wrapper">
      <b-spinner></b-spinner>
    </div>
  </div>

</template>

<script>
import GridMixin from "../../components/grid/GridMixin";
import GridPagination from "../../components/grid/grid-pagination/GridPagination";
// import GridMixin from "../../../components/grid/GridMixin";
// import GridPagination from "../../../components/grid/grid-pagination/GridPagination";
// import SendEmailModal from "./SendEmailModal";
// import SendSmsModal from "./SendSmsModal";
import FilterInput from "../../components/grid/filters/FilterInput";
import FilterSelect from "../../components/grid/filters/FilterSelect";
import FilterDateRangePicker from "../../components/grid/filters/FilterDateRangePicker";
import PageHeader from "../../components/page/PageHeader";
import PageCard from "../../components/page/PageCard";
import ShowModal from "./ShowModal";

export default {
  mixins: [GridMixin],
  components: {
    GridPagination,
    FilterInput,
    FilterSelect,
    FilterDateRangePicker,
    PageHeader,
    PageCard
  },
  data() {
    return {
      gridGetUrl: null,
      show: false,
      orderColumn: 'firstMessageDate',
      fields: [
        {key: 'id', label: this.$t('table.header.messages.id'), sortable: true},
        {key: 'topic', label: this.$t('table.header.messages.topic'), sortable: true},
        {key: 'playerNickName', label: this.$t('table.header.messages.player_nick_name'), sortable: true},
        {key: 'playerEmail', label: this.$t('table.header.messages.player_email'), sortable: true},
        {key: 'playerCountry', label: this.$t('table.header.messages.player_country'), sortable: true},
        {key: 'status', label: this.$t('table.header.messages.status'), sortable: true},
        {key: 'unreadCount', label: this.$t('table.header.messages.unread_count'), sortable: true},
        {key: 'firstMessageDate', label: this.$t('table.header.messages.first_message_date'), sortable: true},
        {key: 'lastMessageDate', label: this.$t('table.header.messages.last_message_date'), sortable: true},
        {key: 'actions', label: this.$t('table.header.actions'), sortable: true},
      ],
      items: [],
      selectOptions: {
        status: [
          {value: 'open', text: this.$t('option.message.open')},
          {value: 'closed', text: this.$t('option.message.closed')},
        ],
        isUnread: [
          {value: true, text: this.$t('option.message.is_unread')},
          {value: false, text: this.$t('option.message.is_not_unread')}
        ],
        type: [
          {value: 'email', text: this.$t('option.message.email')},
          {value: 'sms', text: this.$t('option.message.sms')}
        ]
      },
    };
  },
  mounted() {
    this.getPlayerMessages();

    this.$on('refreshGrid', () => {
      this.getPlayerMessages();
    })
  },
  methods: {
    openModal(data) {
        this.$store.commit('modal/openModal', {
          parent: this,
          modal: ShowModal,
          modalName: 'show-modal',
          props: {apiKey: this.apiKey, message: data}
        });
    },
    getPlayerMessages() {
      this.gridGetUrl = `/api/inbox/message-to-player`;
      this.loadItems();
    }
  },
  computed: {
    player: function () {
      return this.$store.getters['players/player'];
    },
    countries: function () {
      const countries = this.$store.getters['root/country'].map(country => {
        return {
          value: country.key,
          text: country.label
        }
      });

      return countries;
    },
    apiKey: function () {
      return this.$store.getters['root/apiKey'];
    }
  }
}
</script>
